import firebase_api from "@/firebase/firebase_api"; 
import keys from "@/firebase/keys_firebase"
import firebase from "firebase"
const subscription_api = {
   // priceId: "price_1IKKhRJv2Qkf1GvfB687syGB",
    tax_id: keys.keys.stripe.tax_id,
    addCredit (idUser, priceId, success_url, cancel_url) {
        
        firebase_api.api.getDb()
        .collection('customers')
        .doc(idUser)
        .collection('checkout_sessions')
        .add({
            price: priceId,
            allow_promotion_codes: false,
            tax_rates: [this.tax_id],
            success_url: success_url,
            cancel_url: cancel_url
        }).then(docRef=>{
            docRef.onSnapshot(snap=>{
           
            const { error, sessionId } = snap.data();
            if (error) {
                // Show an error to your customer and then inspect your function logs.
                console.log("An error occured: "+error.message);
            }
            if (sessionId) {
                // We have a session, let's redirect to Checkout
                // Init Stripe
                const stripe = Stripe(keys.keys.stripe.pk);
                
                //stripe.redirectToCheckout({ sessionId });
                stripe.redirectToCheckout({
                    sessionId
                })
                .then((result)=> {
                    // If `redirectToCheckout` fails due to a browser or network
                    // error, display the localized error message to your customer
                    // using `result.error.message`.
                    
                });
            }
            });
        })
    },
    async subscribe(idUser, club, choice, success_url, cancel_url) {
        const functions = firebase.app().functions('europe-west1');
        const createProduct = functions.httpsCallable("CreateProduct");
        var params= {
            club: club.name,
            idClub: club.id,
            price: choice.unit_amount,
            recurring: choice.interval
        }
        
        var price = await createProduct(params);
        firebase_api.api.getDb()
        .collection('customers')
        .doc(idUser) 
        .collection('checkout_sessions')
        .add({
            price: price.data.message,
            metadata: {
                club: club.id
            },
            allow_promotion_codes: false,
            tax_rates: [this.tax_id],
            success_url: success_url,
            cancel_url: cancel_url
        }).then(docRef=>{
            docRef.onSnapshot(snap=>{
           
            const { error, sessionId } = snap.data();
            if (error) {
                // Show an error to your customer and then inspect your function logs.
                console.log("An error occured: "+error.message);
            }
            if (sessionId) {
                // We have a session, let's redirect to Checkout
                // Init Stripe
                const stripe = Stripe(keys.keys.stripe.pk);
                //stripe.redirectToCheckout({ sessionId });
                stripe.redirectToCheckout({
                    sessionId
                })
                .then((result)=> {
                    // If `redirectToCheckout` fails due to a browser or network
                    // error, display the localized error message to your customer
                    // using `result.error.message`.
                    
                });
            }
            });
        })
    }
}


export default {
    object: subscription_api
};